/** Feature API — Faz 1.2 createApi factory ile yeniden yazıldı. Önce: 175 satır. */
import {createApi} from './_factory'
import type {CommonNs, FeatureNs} from '@shared/types'

const api = createApi('feature')

const updateFeature = (data: FeatureNs.UpdateFeatureRequest) =>
  api.post<FeatureNs.UpdateFeatureRequest, CommonNs.AnyResponse>('update-feature', data)

const addFeatureList = (data: FeatureNs.UpdateFeatureRequest) =>
  api.post<FeatureNs.UpdateFeatureRequest, FeatureNs.Feature[]>('add-feature-list', data)

export const FeatureApi = {
  // — Liste / okuma —
  getAllFeature: (data: FeatureNs.GetAllFeatureRequest) =>
    api.post<FeatureNs.GetAllFeatureRequest, FeatureNs.Feature[]>('get-all', data),

  // — Tek özellik mutasyonu —
  updateFeature,
  updateFeatureParent: (data: FeatureNs.UpdateFeatureParentRequest) =>
    api.post<FeatureNs.UpdateFeatureParentRequest, FeatureNs.Feature>('update-parent', data),
  duplicateFeature: (data: FeatureNs.UpdateFeatureRequest) =>
    api.post<FeatureNs.UpdateFeatureRequest, FeatureNs.Feature>('duplicate-feature', data),
  deleteFeature: (data: FeatureNs.UpdateFeatureRequest) =>
    api.post<FeatureNs.UpdateFeatureRequest, FeatureNs.Feature>('delete-feature', data),

  // — Grup yönetimi —
  addNewFeatureList: addFeatureList,
  addGroupsWithFeatures: (data: FeatureNs.AddGroupsAndFeaturesRequest) =>
    api.post<FeatureNs.AddGroupsAndFeaturesRequest, FeatureNs.Feature[]>('add-groups-with-features', data),

  // — Arama / import —
  searchFeatureInProjects: (data: FeatureNs.SearchFeatureRequest) =>
    api.post<FeatureNs.SearchFeatureRequest, FeatureNs.SearchFeatureResponse[]>('search-feature', data),
  importFeatureFromOtherProject: (data: FeatureNs.ImportFeatureRequest) =>
    api.post<FeatureNs.ImportFeatureRequest, FeatureNs.Feature[]>('import-feature', data),

  // — Jira sync —
  getWaitingFeatureToSend: (data: FeatureNs.GetAllProjectPageRequest) =>
    api.post<FeatureNs.GetAllProjectPageRequest, FeatureNs.FeatureSynchStatus[]>('waiting-to-send', data),
  sendToJira: (data: FeatureNs.SendToJiraRequest) =>
    api.post<FeatureNs.SendToJiraRequest, CommonNs.AnyResponse>('send-feature-to-jira', data),

  // — Lakap alias'lar (deprecated). Faz 4'te store ile birlikte silinecek. —
  updateShowOrHide: updateFeature,
  /** @deprecated `updateFeature` ile birebir aynı endpoint. */
  changeFeatureColor: (data: FeatureNs.UpdateFeatureRequest) =>
    api.post<FeatureNs.UpdateFeatureRequest, FeatureNs.Feature>('update-feature', data),
  /** @deprecated `addNewFeatureList` ile birebir aynı endpoint. */
  createAGroup: (data: FeatureNs.UpdateFeatureRequest) =>
    api.post<FeatureNs.UpdateFeatureRequest, FeatureNs.Feature>('add-feature-list', data),
}
